import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { Card, ListGroup } from "react-bootstrap"

const Enfants = ({ data }) => {
  return (
    <Layout>
      <SEO title="Enfants" />
      <div className="container pt-5 pb-3">
        <div className="row">
          <div className="col-md-12 mb-4">
            <h2>Enfants</h2>
          </div>
          <div className="col-md-12">
            <p>
              La sophrologie peut se pratiquer à tout âge de la vie. Elle
              s’adresse à tout public, également aux enfants, à partir de 5 ans.
            </p>
          </div>
        </div>
      </div>
      <section className="bg-green py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mb-3">
              <Img
                fluid={data.img1.childImageSharp.fluid}
                alt="Enfant qui souffle sur un pissenlit"
              />
            </div>
            <div className="col-md-6">
              <p>
                <strong>
                  Tout comme les adultes, les enfants et les adolescents ont
                  besoin de moments de respiration, de détente physique et
                  mentale.
                </strong>
              </p>
              <p>
                La sophrologie leur permet de trouver un meilleur équilibre pour
                faire face à des évènements pas toujours faciles à maîtriser,
                notamment&nbsp;:
                <ListGroup variant="flush">
                  {[
                    "Gérer ses émotions",
                    "Préparer des examens (Brevet, Bac, permis de conduire)",
                    "Passer de la vie d’enfant à celle d’adolescent",
                    "Traverser les épreuves de la vie (deuils, séparations, maladies, changements)",
                    "Mieux vivre avec son corps, s’accepter tel que l’on est",
                    "Développer la confiance en soi, son optimisme, se projeter positivement",
                    "Vivre en harmonie avec les autres, avec soi-même et avec les adultes",
                    "Être plus autonome et plus acteur de sa vie, de son bien-être",
                    "Prendre conscience de ses capacités, de ses ressources, de ses potentiels",
                  ].map((item, i) => {
                    return (
                      <ListGroup.Item key={i} style={{ background: "none" }}>
                        <span
                          role="img"
                          aria-label="Backhand Index Pointing Right"
                        >
                          👉
                        </span>{" "}
                        {item}
                      </ListGroup.Item>
                    )
                  })}
                </ListGroup>
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-yellow py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mb-3">
              <p>
                <strong>
                  L’accompagnement sophrologique leur permet de réduire et
                  soulager de nombreux troubles, notamment dans le cadre
                  de&nbsp;:
                </strong>
                <ListGroup variant="flush">
                  {[
                    "Troubles du sommeil : retrouver le sommeil, améliorer sa qualité de sommeil",
                    "Déficit de confiance en soi : restaurer une meilleure image de soi ou estime de soi, retrouver la confiance en soi, en ses capacités, s’accepter tel que l’on est",
                    "Troubles émotionnels : pour réguler les émotions, atténuer stress, anxiété, angoisses, phobies",
                    "Troubles de l’attention, de la concentration, hyperactivité : pour développer ses capacités d’attention, de concentration, installer le calme en soi, apprendre à se recentrer",
                    "Troubles de la motricité : découverte de son schéma corporel, développement de la conscience du corps (sensorialité, tonus musculaire, postures, latéralité, équilibre, précision), de sa place dans l’espace",
                  ].map((item, i) => {
                    return (
                      <ListGroup.Item key={i} style={{ background: "none" }}>
                        <span
                          role="img"
                          aria-label="Backhand Index Pointing Right"
                        >
                          👉
                        </span>{" "}
                        {item}
                      </ListGroup.Item>
                    )
                  })}
                </ListGroup>
              </p>
              <p>
                La sophrologie étant une méthode douce et qui s’adapte à tous,
                chacun peut pratiquer dans le respect de ses limites et de ses
                capacités.
              </p>
            </div>
            <div className="col-md-6">
              <Img
                fluid={data.img2.childImageSharp.fluid}
                alt="Main qui reçoit une plume"
              />
            </div>
          </div>
        </div>
      </section>
      <div className="container pt-5 pb-3">
        <div className="row">
          <div className="col-md-12">
            <p className="text-center">
              <Card border="danger" style={{ width: "100%" }}>
                <Card.Header>À savoir</Card.Header>
                <Card.Body>
                  <Card.Text>
                    Bien sûr, la sophrologie ne se substitue jamais à un
                    traitement médical. Elle intervient en complément ou en
                    soutien d’une prise en charge médicale.
                  </Card.Text>
                </Card.Body>
              </Card>
            </p>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query {
    img1: file(relativePath: { eq: "enfant-1.jpg" }) {
      relativePath
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    img2: file(relativePath: { eq: "enfant-2.jpg" }) {
      relativePath
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`

export default Enfants
